// extracted by mini-css-extract-plugin
export default {"link":"other_link__Wuzhb","next":"other_next__DbV8p"};